
import * as yup from 'yup'


// initial
export const initialValuesDeposit = {
  user_id: '',
  transaction_code: '',
  amount: '',
  content: '',
}

export const initialValuesDeduct = {
  user_id: '',
  transaction_code: '',
  amount: '',
  content: '',
}

export const initialValuesWithdrawProcess = (data: any) => {
  console.log(data, 'initialValuesWithdrawProcess');

  return {
    id: data?.id || null,
    full_name: data?.requestor?.full_name,
    transaction_code: data.transaction_code,
    amount: data.amount,
    note: '',
    status: data?.status || 'pending',
  }
}


export const schemaDeposit = yup.object({
  user_id: yup.string().required('Tài khoản là bắt buộc'),
  transaction_code: yup.string().required('Mã giao dịch là bắt buộc'),
  amount: yup.string().required('Số tiền là bắt buộc'),
  content: yup.string().required('Nội dung là bắt buộc'),
})


export const schemaDeduct = yup.object({
  user_id: yup.string().required('Tài khoản là bắt buộc'),
  transaction_code: yup.string().required('Mã giao dịch là bắt buộc'),
  amount: yup.string().required('Số tiền là bắt buộc'),
  content: yup.string().required('Nội dung là bắt buộc'),
})

export const schemaWithdrawProcess = yup.object({
  note: yup.string().required('Ghi chú là bắt buộc'),
  //status: paid, rejected
  status: yup.string().oneOf(['paid', 'rejected'], 'Trạng thái chưa được Xử lí'),
})
